/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-26 11:24:12
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-08-05 16:20:24
 * @FilePath: /qd-yunjing-web/src/router/modules/safety.ts
 * @Description: 这是默认设置,请设置`customMade`, BD%AE
 */
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

export const ibmsRoutes: RouteRecordRaw[] = [
  {
    path: '/ibms',
    name: 'ibm-root',
    component: Layout,
    meta: {
      authCodes: ['IBMS'],
      icon: 'BarFull',
      title: '运行',
    },
    children: [
      {
        path: '/ibm/index',
        name: 'ibm-index',
        component: () => import('@/views/ibms/index.vue'),
        meta: {
          authCodes: ['INDICATOR_OPERATION_DASHBOARD'],
          title: '指标运营看板',
          activeMenu: '/ibms',
        },
      },
      {
        path: '/ibm/overview',
        name: 'ibm-overview',
        component: () => import('@/views/ibms/overview.vue'),
        meta: {
          authCodes: ['EQUIPMENT_OPERATION_OVERVIEW'],
          title: '设备运行概览',
          activeMenu: '/ibms',
        },
      },
      {
        path: '/monitor/index',
        name: 'monitor-index',
        component: () => import('@/views/ibms/monitor.vue'),
        meta: {
          authCodes: ['DEVICE_MONITOR'],
          title: '设备监控',
          activeMenu: '/ibms',
          projectCheckStrictly: true,
          isThreeModel: true,
        },
      },
      {
        path: '/monitor/router',
        name: 'monitor-router',
        component: () => import('@/views/ibms/device-router.vue'),
        meta: {
          authCodes: ['DEVICE_ROUTER'],
          title: '设备路由',
          activeMenu: '/ibms',
          projectCheckStrictly: true,
          isThreeModel: true,
        },
      },
      {
        path: '/environment',
        name: 'environment',
        meta: {
          authCodes: ['ENVIRONMENT_DETECTION'],
          title: '环境监测',
          activeMenu: '/ibms',
        },
        children: [
          {
            path: '/environment/index',
            name: 'environment-index',
            component: () => import('@/views/ibms/environment.vue'),
            meta: {
              authCodes: ['REAL_TIME_ENVIRONMENTAL_MONITOR'],
              title: '环境实时监测',
              activeMenu: '/ibms',
              projectCheckStrictly: true,
              isThreeModel: false,
            },
          },
          {
            path: '/environment/home',
            name: 'environment-home',
            component: () => import('@/views/ibms/environment.vue'),
            meta: {
              authCodes: ['REAL_TIME_ENVIRONMENTAL_MONITOR'],
              title: '环境实时监测',
              activeMenu: '/ibms',
              projectCheckStrictly: true,
              isThreeModel: true,
            },
          }
        ],
      },
      {
        path: '/ibm/rule',
        name: 'ibm-alarm-rule',
        meta: {
          authCodes: [
            'IBMS_ALARM_CONFIG',
            'NORMAL_ALARM',
            'LOGICAL_ALARM_RULES'
          ],
          title: '告警规则',
          activeMenu: '/ibms',
        },
        children: [
          {
            path: '/ibm/rule/ordinary',
            name: 'ibm-ordinary',
            component: () => import('@/views/safety/alarm-config/normal-alarm.vue'),
            meta: {
              authCodes: ['NORMAL_ALARM'],
              title: '普通告警规则',
              activeMenu: '/ibms',
            },
          },
          {
            path: '/ibm/rule/logic',
            name: 'ibm-logic',
            component: () => import('@/views/ibms/logic-rule.vue'),
            meta: {
              authCodes: ['LOGICAL_ALARM_RULES'],
              title: '逻辑告警规则',
              activeMenu: '/ibms',
            },
          }
        ],
      },
      {
        path: '/ibm/data',
        name: 'ibm-data',
        component: () => import('@/views/ibms/data.vue'),
        meta: {
          authCodes: ['DATA_ANALYSIS'],
          title: '数据分析',
          activeMenu: '/ibms',
        },
      },
      {
        path: '/ibm/workorder-replay',
        name: 'ibm-workorde-replay',
        component: () => import('@/views/ibms/workorder-replay.vue'),
        meta: {
          authCodes: ['WORK_ORDER_BLOCKING'],
          title: '工单屏蔽',
          activeMenu: '/ibms',
        },
      }
    ],
  }
];
